const isBlacklistedFilter = {
  namespaced: true,
  state: {
    data: null
  },
  mutations: {
    SET_DATA(state, data) {
      state.data = data;
    }
  },
  actions: {
    setData(context, value) {
      context.commit("SET_DATA", value);
    }
  },
  getters: {
    data: state => {
      return state.data;
    },
    toParams: state => {
      return [
        { column: "exists[blacklistSku]", value: state.data }
      ];
    }
  }
};

export default isBlacklistedFilter;
